import { render, staticRenderFns } from "./defra-types.vue?vue&type=template&id=746b42ac&scoped=true"
import script from "./defra-types.vue?vue&type=script&lang=js"
export * from "./defra-types.vue?vue&type=script&lang=js"
import style0 from "./defra-types.vue?vue&type=style&index=0&id=746b42ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b42ac",
  null
  
)

export default component.exports